import React, { useState } from 'react'

import currency from '@/screens/Product/page/assets/currency-ruble-circle.svg'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'
import { Icon } from '@/shared/ui/icon'

import { FoundLowerPriceForm } from './components/found-lower-price-form/FoundLowerPriceForm'

import cl from './found-lower-price-block.module.scss'

export const FoundLowerPriceBlock = () => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const onOpen = () => setIsModalOpen(true)
	return (
		<>
			<button className={cl.root} onClick={onOpen}>
				<Icon icon={currency} width={24} height={24} aria-label="icon" />
				<span>Нашли дешевле? Снизим цену</span>
				<SvgArrowDown size={20} className={cl.icon} />
			</button>

			{isModalOpen && <FoundLowerPriceForm isOpened={isModalOpen} setIsModalOpen={setIsModalOpen} />}
		</>
	)
}
